import React from 'react';

// Risk category configurations aligned with ML thresholds
const CATEGORY_CONFIG = {
  low: {
    color: '#22C55E',
    bgColor: 'bg-green-100',
    textColor: 'text-green-800',
    borderColor: 'border-green-300',
    label: 'Low Risk',
    range: '1-2',
  },
  medium: {
    color: '#F59E0B',
    bgColor: 'bg-yellow-100',
    textColor: 'text-yellow-800',
    borderColor: 'border-yellow-300',
    label: 'Medium Risk',
    range: '2-3',
  },
  high: {
    color: '#F97316',
    bgColor: 'bg-orange-100',
    textColor: 'text-orange-800',
    borderColor: 'border-orange-300',
    label: 'High Risk',
    range: '3-4',
  },
  critical: {
    color: '#EF4444',
    bgColor: 'bg-red-100',
    textColor: 'text-red-800',
    borderColor: 'border-red-600',
    label: 'Critical',
    range: '4-5',
  },
};

/**
 * RiskCategoryBadge - Color-coded badge for risk category display
 */
const RiskCategoryBadge = ({ category, showRange = false, size = 'md' }) => {
  const config = CATEGORY_CONFIG[category] || CATEGORY_CONFIG.low;

  const sizeClasses = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-3 py-1 text-sm',
    lg: 'px-4 py-1.5 text-base',
  };

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full font-medium ${config.bgColor} ${config.textColor} ${sizeClasses[size]}`}
    >
      <span
        className="w-2 h-2 rounded-full"
        style={{ backgroundColor: config.color }}
      />
      <span>{config.label}</span>
      {showRange && (
        <span className="opacity-70">({config.range})</span>
      )}
    </span>
  );
};

export default RiskCategoryBadge;
export { CATEGORY_CONFIG };
